/** Textos da secção "servers". Chaves planas "servers.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "servers.eyebrow": "Rede ZRS",
    "servers.title": "Servidores Ativos",
    "servers.bannerAria": "Marca ZRS",
    "servers.online": "Online",
    "servers.offline": "Offline",
    "servers.loading": "A carregar…",
    "servers.labelPlayers": "Players",
    "servers.labelRates": "Taxas",
    "servers.labelLootSpawn": "Spawn de caixas",
    "servers.lootBoosted": "Spawn de caixas aumentado",
    "servers.labelWipe": "Wipe",
    "servers.labelUptime": "Uptime",
    "servers.labelMap": "Mapa",
    "servers.viewMap": "Ver mapa",
    "servers.viewMapAria": "Ver o mapa no RustMaps (abre noutro separador)",
    "servers.stale": "Dados em cache (ligação à API indisponível).",
    "servers.queue": "fila {n}",
    "servers.notAvailable": "N/D",
    "servers.wipeToday": "Wipe hoje",
    "servers.wipeOneDay": "Wipe há 1 dia",
    "servers.wipeDays": "Wipe há {n} dias",
    "servers.nextWipeIsToday": "próximo é hoje",
    "servers.nextWipeOn": "próximo {date}",
    "servers.nextWipeOnly": "Próximo wipe {date}",
    "servers.connect": "Conectar",
    "servers.connectHint": "Copia o comando para a consola do Rust (F1)",
    "servers.copied": "Copiado! Abre o Rust, carrega F1 e cola o comando.",
    "servers.copyFailed": "Não foi possível copiar. Copia manualmente: {command}",
};
const en = {
    "servers.eyebrow": "ZRS Network",
    "servers.title": "Live Servers",
    "servers.bannerAria": "ZRS logo",
    "servers.online": "Online",
    "servers.offline": "Offline",
    "servers.loading": "Loading…",
    "servers.labelPlayers": "Players",
    "servers.labelRates": "Rates",
    "servers.labelLootSpawn": "Crate spawn",
    "servers.lootBoosted": "Boosted crate spawn",
    "servers.labelWipe": "Wipe",
    "servers.labelUptime": "Uptime",
    "servers.labelMap": "Map",
    "servers.viewMap": "View map",
    "servers.viewMapAria": "View the map on RustMaps (opens in a new tab)",
    "servers.stale": "Cached data (API connection unavailable).",
    "servers.queue": "queue {n}",
    "servers.notAvailable": "N/A",
    "servers.wipeToday": "Wiped today",
    "servers.wipeOneDay": "Wiped 1 day ago",
    "servers.wipeDays": "Wiped {n} days ago",
    "servers.nextWipeIsToday": "next one is today",
    "servers.nextWipeOn": "next {date}",
    "servers.nextWipeOnly": "Next wipe {date}",
    "servers.connect": "Connect",
    "servers.connectHint": "Copies the command for the Rust console (F1)",
    "servers.copied": "Copied! Open Rust, press F1 and paste the command.",
    "servers.copyFailed": "Couldn't copy. Copy it manually: {command}",
};

export default { pt, en };
